<style>
  .line-height20{
    line-height: 19px;
  }
</style>
<template>
  <div class="warning-box">
    <div class="shade-box ">
      <div class="shade-content position-top">
        <p class="dialog-title-bg line-height20">设置短信预警值
        <button type="button" aria-label="Close" class="el-dialog__headerbtn"   @click="cancelset('setWarningForm')"><i class="el-icon-circle-close-outline"></i></button></p>
        <div class="el-dialog__body">
          <el-form :model="reviseForm" ref="setWarningForm" label-width="100px" class="demo-ruleForm" :rules="$rules">
            <el-form-item label="当前预警值">
              <el-input v-model="$store.state.balanceSizeWarn"></el-input>
            </el-form-item>
            <el-form-item label="预警值" prop="balanceSizeWarn">
              <el-input v-model="reviseForm.balanceSizeWarn" placeholder="请输入预警值" maxlength="10" ref="warningInput" auto-complete="off" @keyup.enter.native="submitForm('setWarningForm')"></el-input>
            </el-form-item>
            <el-form-item class="marginTop30">
              <el-button type="primary paddingTB7" @click="submitForm('setWarningForm')" :disabled="disabled">确认</el-button>
              <el-button @click="cancelset('setWarningForm')">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from '../../server/api.js'
import axios from 'axios'
export default {
  name: "warning",
  data(){
    return{
      disabled: false,
      reviseForm: {
       balanceSizeWarn: '',
      },
    };
  },
  created(){
    this.$nextTick(function(){
      this.$refs.warningInput.focus();
    });
  },
  methods: {
    submitForm(formName){//修改
      let _this = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.disabled = true;
          let formData = new FormData()
          formData.append('balanceSizeWarn',parseInt(_this.reviseForm.balanceSizeWarn));
          axios.post('user/home/setBalanceSizeWarn',formData,{headers:{'Content-Type':'application/x-www-form-urlencoded'}}).then(res=>{
            console.log(res)
            this.disabled = false;
            if(res.data.status == 'success'){
              _this.$message.success(res.data.msg);
              _this.cancelset('setWarningForm');
            }
          })
        } else {
          return false;
        }
      });
    },
    cancelset(formName){//取消修改
      this.$refs[formName].resetFields();
      this.$emit('colseWarning');
    }
  },
  components: {
    
  }
}
</script>
  




// WEBPACK FOOTER //
// src/components/layout/warning.vue